import { ReactStateType } from "@xnav/types/src/frontend"
import { createContext } from "react"

export type RequestError = {stack: string, message: string, name: string, code: string, config: string, request: string}

export const ProblemContext = createContext([undefined, () => { }] as ReactStateType<RequestError | undefined>)
